<template>
  <ReportWrapper>
    <template #actions>
      <div class="flex gap-x-2">
        <CustomerAutocomplete
          v-model="selectedCustomer"
          class="w-2/6 x-sm:w-full"
          label=""
          placeholder="Customer"
          customer
          hide-details
          :return-object="false"
          item-value="accountNumber"
        />
        <CfsDateField v-model="selectedDateRange" placeholder="Select date range" range />
      </div>

      
      <v-btn
        color="primary"
        :loading="isLoading"
        @click="download"
      >
        <v-icon size="1rem" class="mr-1">mdi-tray-arrow-down</v-icon>
        <span>Download</span>
      </v-btn>
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFile } from '@/helpers/download';
import { useToast } from '@/composables/useToast';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';
import { AxiosError } from 'axios';

export default defineComponent({
  name: 'CustomerInvoicesReport',
  components: {
    ReportWrapper,
    CustomerAutocomplete: defineAsyncComponent(
      () => import('@/components/autocomplete/CustomerAutocompleteComponent.vue')
    ),
  },
  setup() {
    const toast = useToast();

    const selectedCustomer = ref<string | null>(null);
    const selectedDateRange = ref<{ start: string; end: string } | null>(null);

    const { useDownloadCustomerInvoicesReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadCustomerInvoicesReport();

    const download = async () => {
      if (!selectedCustomer.value || !selectedDateRange.value)
        return toast.info('Please select customer and date.');

      try {
        const data = await downloadReport({
          customer: selectedCustomer.value,
          dateRange: selectedDateRange.value
        });

        if (!data) return;

        downloadFile(data.base64Data, data.filename ?? 'Customer Invoices Report');
      } catch (error) {
        const axiosError = error as AxiosError<string>;
        toast.error(axiosError?.response?.data!);
      }
    };

    return { selectedDateRange, selectedCustomer, isLoading, download };
  },
});
</script>
